import React from 'react'
import { SvgIcon } from '@material-ui/core'

function DirectBusinessIcon(props) {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <ellipse
        cx='11.4462'
        cy='12.8955'
        rx='11.4462'
        ry='11.1045'
        fill='#E9ECFF'
      />
      <g clipPath='url(#clip0)'>
        <path
          d='M12.3177 2.91163L17.1593 7.57796L18.3586 6.42208L13.517 1.75575L14.9384 0.428631C15.5158 -0.127903 16.4042 -0.127903 16.9816 0.428631L19.78 3.12568L16.9816 0.428631C16.4042 -0.127903 15.5158 -0.127903 14.9384 0.428631L8.71973 6.42208L13.5614 11.0884L12.14 12.4155C11.9623 12.5868 11.7846 12.6724 11.607 12.758C11.7846 12.6724 12.0067 12.5868 12.14 12.4155L14.7607 9.88972L9.91904 5.2662L12.3177 2.91163Z'
          fill='white'
        />
        <path
          d='M12.3177 2.91163L17.1593 7.57796L18.3586 6.42208L13.517 1.75575L14.9384 0.428631C15.5158 -0.127903 16.4042 -0.127903 16.9816 0.428631L19.78 3.12568L16.9816 0.428631C16.4042 -0.127903 15.5158 -0.127903 14.9384 0.428631L8.71973 6.42208L13.5614 11.0884L12.14 12.4155C11.9623 12.5868 11.7846 12.6724 11.607 12.758C11.7846 12.6724 12.0067 12.5868 12.14 12.4155L14.7607 9.88972L9.91904 5.2662L12.3177 2.91163Z'
          fill='url(#paint0_linear)'
        />
        <path
          d='M17.1592 7.57746L12.3176 2.91113L9.91895 5.22289L14.7162 9.88922L21.2458 16.1823C21.6455 16.5676 22.2674 16.5676 22.6672 16.1823L23.6444 15.2405C24.0441 14.8552 24.0441 14.2559 23.6444 13.8706L17.1592 7.57746Z'
          fill='#00C3FF'
        />
        <path
          d='M13.5174 11.088L8.67579 6.42163L7.29881 7.74875C6.72136 8.30529 6.72136 9.16149 7.29881 9.71803L10.0972 12.4151C10.497 12.8004 11.0744 12.9288 11.6074 12.7576C11.7851 12.6719 12.0072 12.5863 12.1405 12.4151L13.5174 11.088Z'
          fill='#00C3FF'
        />
        <path
          d='M14.9385 0.428631L13.5615 1.75575L18.3588 6.42208L19.7357 5.09496C20.3132 4.53842 20.3132 3.68222 19.7357 3.12568L16.9818 0.428631C16.4043 -0.127903 15.4715 -0.127903 14.9385 0.428631Z'
          fill='#00C3FF'
        />
        <path
          d='M15.6937 15.8828H7.12081C6.67663 15.8828 6.27686 16.2681 6.27686 16.6962C6.27686 17.1671 6.67663 17.5524 7.12081 17.5524H15.6492C16.1378 17.5524 16.4932 17.1671 16.4932 16.739C16.5376 16.2681 16.1378 15.8828 15.6937 15.8828Z'
          fill='#00C3FF'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear'
          x1='4.18416'
          y1='-3.15429'
          x2='7.29239'
          y2='0.0707629'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00074314' stopColor='#39A7DF' />
          <stop offset='1' stopColor='#29265B' />
        </linearGradient>
        <clipPath id='clip0'>
          <rect
            width='17.7231'
            height='17.5522'
            fill='white'
            transform='translate(6.27686)'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default DirectBusinessIcon
